/** Préférence mode caisse immersif (session navigateur — pas de perte panier/table). */
export const POS_IMMERSIVE_PREF = 'clickorico_pos_immersive_v1';
export const POS_IMMERSIVE_DOM_FLAG = 'posImmersiveActive';

export function readPosImmersivePreference() {
  try {
    return sessionStorage.getItem(POS_IMMERSIVE_PREF) === '1';
  } catch {
    return false;
  }
}

export function writePosImmersivePreference(active) {
  try {
    if (active) sessionStorage.setItem(POS_IMMERSIVE_PREF, '1');
    else sessionStorage.removeItem(POS_IMMERSIVE_PREF);
  } catch {
    /* Safari private mode */
  }
}

export function syncPosImmersiveDomFlag(active) {
  if (typeof document === 'undefined') return;
  if (active) {
    document.documentElement.dataset[POS_IMMERSIVE_DOM_FLAG] = '1';
  } else {
    delete document.documentElement.dataset[POS_IMMERSIVE_DOM_FLAG];
  }
}

/** Fullscreen API — iPad Safari : souvent indisponible sur document ; best-effort. */
export async function requestPosBrowserFullscreen() {
  if (typeof document === 'undefined') return { ok: false, reason: 'no_document' };
  const el = document.documentElement;
  const fn =
    el.requestFullscreen
    || el.webkitRequestFullscreen
    || el.webkitEnterFullscreen;
  if (!fn) return { ok: false, reason: 'unsupported' };
  try {
    await fn.call(el);
    return { ok: true };
  } catch {
    return { ok: false, reason: 'denied' };
  }
}

export async function exitPosBrowserFullscreen() {
  if (typeof document === 'undefined') return;
  const doc = document;
  const fn =
    doc.exitFullscreen
    || doc.webkitExitFullscreen
    || doc.webkitCancelFullScreen;
  if (!fn) return;
  try {
    if (doc.fullscreenElement || doc.webkitFullscreenElement) {
      await fn.call(doc);
    }
  } catch {
    /* ignore */
  }
}

export function isStandalonePwaDisplayMode() {
  if (typeof window === 'undefined') return false;
  try {
    return (
      window.matchMedia('(display-mode: standalone)').matches
      || window.navigator.standalone === true
    );
  } catch {
    return false;
  }
}
